import { CALL_API } from '../middleware/ApiMiddleware';

export const CONTACTS_FETCH_REQUEST = 'CONTACTS_FETCH_REQUEST';
export const CONTACTS_FETCH_SUCCESS = 'CONTACTS_FETCH_SUCCESS';
export const CONTACTS_FETCH_FAILURE = 'CONTACTS_FETCH_FAILURE';

export const FETCH_CONTACTS_LIST_REQUEST = 'FETCH_CONTACTS_LIST_REQUEST';
export const FETCH_CONTACTS_LIST_SUCCESS = 'FETCH_CONTACTS_LIST_SUCCESS';
export const FETCH_CONTACTS_LIST_FAILURE = 'FETCH_CONTACTS_LIST_FAILURE';
export const LOAD_MORE_CONTACTS = 'LOAD_MORE_CONTACTS';

export const CASE_ROLES_FETCH_REQUEST = 'CASE_ROLES_FETCH_REQUEST';
export const CASE_ROLES_FETCH_SUCCESS = 'CASE_ROLES_FETCH_SUCCESS';
export const CASE_ROLES_FETCH_FAILURE = 'CASE_ROLES_FETCH_FAILURE';

export const CONTACT_CREATE_REQUEST = 'CONTACT_CREATE_REQUEST';
export const CONTACT_CREATE_SUCCESS = 'CONTACT_CREATE_SUCCESS';
export const CONTACT_CREATE_FAILURE = 'CONTACT_CREATE_FAILURE';

export const DUPLICATE_CONTACTS_REQUEST = 'DUPLICATE_CONTACTS_REQUEST';
export const DUPLICATE_CONTACTS_SUCCESS = 'DUPLICATE_CONTACTS_SUCCESS';
export const DUPLICATE_CONTACTS_FAILURE = 'DUPLICATE_CONTACTS_FAILURE';

export const CHECK_DUPLICATE_CONTACT_REQUEST = 'CHECK_DUPLICATE_CONTACT_REQUEST';
export const CHECK_DUPLICATE_CONTACT_SUCCESS = 'CHECK_DUPLICATE_CONTACT_SUCCESS';
export const CHECK_DUPLICATE_CONTACT_FAILURE = 'CHECK_DUPLICATE_CONTACT_FAILURE';

export const CONTACT_FETCH_REQUEST = 'CONTACT_FETCH_REQUEST';
export const CONTACT_FETCH_SUCCESS = 'CONTACT_FETCH_SUCCESS';
export const CONTACT_FETCH_FAILURE = 'CONTACT_FETCH_FAILURE';

export const CONTACT_EDIT_REQUEST = 'CONTACT_EDIT_REQUEST';
export const CONTACT_EDIT_SUCCESS = 'CONTACT_EDIT_SUCCESS';
export const CONTACT_EDIT_FAILURE = 'CONTACT_EDIT_FAILURE';

export const CONTACT_ID_FETCH_REQUEST = 'CONTACT_ID_FETCH_REQUEST';
export const CONTACT_ID_FETCH_SUCCESS = 'CONTACT_ID_FETCH_SUCCESS';
export const CONTACT_ID_FETCH_FAILURE = 'CONTACT_ID_FETCH_FAILURE';

export const CONTACTS_HISTORY_FETCH_REQUEST = 'CONTACTS_HISTORY_FETCH_REQUEST';
export const CONTACTS_HISTORY_FETCH_SUCCESS = 'CONTACTS_HISTORY_FETCH_SUCCESS';
export const CONTACTS_HISTORY_FETCH_FAILURE = 'CONTACTS_HISTORY_FETCH_FAILURE';

export const FETCH_EXTERNAL_CONTACTS_REQUEST = 'FETCH_EXTERNAL_CONTACTS_REQUEST';
export const FETCH_EXTERNAL_CONTACTS_SUCCESS = 'FETCH_EXTERNAL_CONTACTS_SUCCESS';
export const FETCH_EXTERNAL_CONTACTS_FAILURE = 'FETCH_EXTERNAL_CONTACTS_FAILURE';

export const FETCH_CONTACT_SUGGESTIONS_REQUEST = 'FETCH_CONTACT_SUGGESTIONS_REQUEST';
export const FETCH_CONTACT_SUGGESTIONS_SUCCESS = 'FETCH_CONTACT_SUGGESTIONS_SUCCESS';
export const FETCH_CONTACT_SUGGESTIONS_FAILURE = 'FETCH_CONTACT_SUGGESTIONS_FAILURE';

export const CONTACTS_CLEAR = 'CONTACTS_FETCH_CLEAR';
export const SUGGESTED_CONTACTS_CLEAR = 'SUGGESTED_CONTACTS_FETCH_CLEAR';
export const SET_DRAFT_CONTACTS = 'SET_DRAFT_CONTACTS';

export const CONTACT_MERGE_REQUEST = 'CONTACT_MERGE_REQUEST';
export const CONTACT_MERGE_SUCCESS = 'CONTACT_MERGE_SUCCESS';
export const CONTACT_MERGE_FAILURE = 'CONTACT_MERGE_FAILURE';

export const REASSIGN_SUBMISSIONS_REQUEST = 'REASSIGN_SUBMISSIONS_REQUEST';
export const REASSIGN_SUBMISSIONS_SUCCESS = 'REASSIGN_SUBMISSIONS_SUCCESS';
export const REASSIGN_SUBMISSIONS_FAILURE = 'REASSIGN_SUBMISSIONS_FAILURE';

export const CREATE_CC_LIST_REQUEST = 'CREATE_CC_LIST_REQUEST';
export const CREATE_CC_LIST_SUCCESS = 'CREATE_CC_LIST_SUCCESS';
export const CREATE_CC_LIST_FAILURE = 'CREATE_CC_LIST_FAILURE';

export const DOWNLOAD_CONTACT_LIST_CSV_REQUEST = 'DOWNLOAD_CONTACT_LIST_CSV_REQUEST';
export const DOWNLOAD_CONTACT_LIST_CSV_SUCCESS = 'DOWNLOAD_CONTACT_LIST_CSV_SUCCESS';
export const DOWNLOAD_CONTACT_LIST_CSV_FAILURE = 'DOWNLOAD_CONTACT_LIST_CSV_FAILURE';

export const GET_CONSTANT_CONTACT_OAUTH_URI_REQUEST = 'GET_CONSTANT_CONTACT_OAUTH_URI_REQUEST';
export const GET_CONSTANT_CONTACT_OAUTH_URI_SUCCESS = 'GET_CONSTANT_CONTACT_OAUTH_URI_SUCCESS';
export const GET_CONSTANT_CONTACT_OAUTH_URI_FAILURE = 'GET_CONSTANT_CONTACT_OAUTH_URI_FAILURE';

export const DISCONNECT_CONSTANT_CONTACT_REQUEST = 'DISCONNECT_CONSTANT_CONTACT_REQUEST';
export const DISCONNECT_CONSTANT_CONTACT_SUCCESS = 'DISCONNECT_CONSTANT_CONTACT_SUCCESS';
export const DISCONNECT_CONSTANT_CONTACT_FAILURE = 'DISCONNECT_CONSTANT_CONTACT_FAILURE';

export const GET_CAMPAIGN_URL_REQUEST = 'GET_CAMPAIGN_URL_REQUEST';
export const GET_CAMPAIGN_URL_SUCCESS = 'GET_CAMPAIGN_URL_SUCCESS';
export const GET_CAMPAIGN_URL_FAILURE = 'GET_CAMPAIGN_URL_FAILURE';

export const EXPORT_LIST_TO_CC_REQUEST = 'EXPORT_LIST_TO_CC_REQUEST';
export const EXPORT_LIST_TO_CC_SUCCESS = 'EXPORT_LIST_TO_CC_SUCCESS';
export const EXPORT_LIST_TO_CC_FAILURE = 'EXPORT_LIST_TO_CC_FAILURE';

export const AUTH0_FORGOT_PASSWORD_REQUEST = 'AUTH0_FORGOT_PASSWORD_REQUEST';
export const AUTH0_FORGOT_PASSWORD_SUCCESS = 'AUTH0_FORGOT_PASSWORD_SUCCESS';
export const AUTH0_FORGOT_PASSWORD_FAILURE = 'AUTH0_FORGOT_PASSWORD_FAILURE';

export const FETCH_MATCHING_CONTACTS_REQUEST = 'FETCH_MATCHING_CONTACTS_REQUEST';
export const FETCH_MATCHING_CONTACTS_SUCCESS = 'FETCH_MATCHING_CONTACTS_SUCCESS';
export const FETCH_MATCHING_CONTACTS_FAILURE = 'FETCH_MATCHING_CONTACTS_FAILURE';

export const fetchContacts = (
  query: string,
  ownerDetails?: IOwnerDetails,
  excludeContactIds?: number[],
  type?: ContactType,
  isSearchByLocation: boolean = false,
  hideLoadingWidget: boolean = true,
  limit: number = 25
) => {
  const { ownerName = null, ownerAddress = null, missingAddress = false } = ownerDetails ?? {};
  const params: any = {};
  params.limit = limit;
  if (type) {
    params.type = type;
  }
  if (excludeContactIds) {
    params.excludeContactIds = excludeContactIds;
  }

  if (isSearchByLocation) {
    params.location = query;
  } else {
    params.q = query;
  }

  params.ownerAddress = ownerAddress;
  params.ownerName = ownerName;
  params.missingAddress = missingAddress;

  return {
    [CALL_API]: {
      endpoint: 'contacts',
      params,
      method: 'get',
      authenticated: true,
      types: [CONTACTS_FETCH_REQUEST, CONTACTS_FETCH_SUCCESS, CONTACTS_FETCH_FAILURE],
      hideLoadingWidget,
    },
  };
};

export const fetchContactsList = (
  reqParams: IContactListFilters,
  replaceResults: boolean = false,
  hideLoadingWidget: boolean = false
) => {
  const params: IContactListFilters = { ...reqParams };
  const { offset } = params;

  return {
    [CALL_API]: {
      endpoint: 'contacts/list',
      params,
      method: 'get',
      authenticated: true,
      types: [
        FETCH_CONTACTS_LIST_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_CONTACTS : FETCH_CONTACTS_LIST_SUCCESS,
        FETCH_CONTACTS_LIST_FAILURE,
      ],
      hideLoadingWidget,
    },
  };
};

export const downloadContactListCSV = (contactListId: number) => {
  const queryParams: any = {};

  return {
    [CALL_API]: {
      endpoint: `contacts/list/download/${contactListId}`,
      method: 'post',
      params: queryParams,
      body: {},
      authenticated: true,
      types: [DOWNLOAD_CONTACT_LIST_CSV_REQUEST, DOWNLOAD_CONTACT_LIST_CSV_SUCCESS, DOWNLOAD_CONTACT_LIST_CSV_FAILURE],
    },
  };
};

export const clearContacts = () => ({
  type: CONTACTS_CLEAR,
});

export const fetchCaseRoles = (agencyId: number, productId: number, hideLoadingWidget: boolean = true) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/products/${productId}/case-roles`,
    method: 'get',
    authenticated: true,
    types: [CASE_ROLES_FETCH_REQUEST, CASE_ROLES_FETCH_SUCCESS, CASE_ROLES_FETCH_FAILURE],
    hideLoadingWidget,
  },
});

export const createContact = (newContact: IContactRequest) => ({
  [CALL_API]: {
    endpoint: 'contacts',
    method: 'post',
    body: newContact,
    authenticated: true,
    types: [CONTACT_CREATE_REQUEST, CONTACT_CREATE_SUCCESS, CONTACT_CREATE_FAILURE],
  },
});

export const findDuplicateContacts = (contact: IContactRequest, hideLoadingWidget: boolean = true) => ({
  [CALL_API]: {
    endpoint: 'xerce/contacts/duplicates',
    method: 'post',
    body: contact,
    authenticated: true,
    types: [DUPLICATE_CONTACTS_REQUEST, DUPLICATE_CONTACTS_SUCCESS, DUPLICATE_CONTACTS_FAILURE],
    hideLoadingWidget,
  },
});

export const getContact = (contactId: number, type: ContactType, includeCaseAndIssueDetails: boolean = false) => ({
  [CALL_API]: {
    endpoint: `contacts/${contactId}`,
    method: 'get',
    params: { type, includeCaseAndIssueDetails },
    authenticated: true,
    types: [CONTACT_FETCH_REQUEST, CONTACT_FETCH_SUCCESS, CONTACT_FETCH_FAILURE],
  },
});

export const editContact = (contactId: number, contact: IContactRequest) => ({
  [CALL_API]: {
    endpoint: `contacts/${contactId}`,
    method: 'put',
    body: contact,
    authenticated: true,
    types: [CONTACT_EDIT_REQUEST, CONTACT_EDIT_SUCCESS, CONTACT_EDIT_FAILURE],
  },
});

export const getSuggestedContacts = (location: string) => ({
  [CALL_API]: {
    endpoint: 'xerce/contacts/suggestions',
    method: 'get',
    authenticated: true,
    params: { location },
    types: [FETCH_CONTACT_SUGGESTIONS_REQUEST, FETCH_CONTACT_SUGGESTIONS_SUCCESS, FETCH_CONTACT_SUGGESTIONS_FAILURE],
  },
});

export const clearSuggestedContacts = () => ({
  type: SUGGESTED_CONTACTS_CLEAR,
});

export const setDraftContacts = (draftContacts) => ({
  type: SET_DRAFT_CONTACTS,
  draftContacts,
});

export const getContactId = (phoneNumber: string, name: string = '') => ({
  [CALL_API]: {
    endpoint: 'agencies/contacts',
    method: 'get',
    params: { phoneNumber, name },
    authenticated: true,
    types: [CONTACT_ID_FETCH_REQUEST, CONTACT_ID_FETCH_SUCCESS, CONTACT_ID_FETCH_FAILURE],
  },
});

export const getExternalContacts = (externalContact: IExternalContactRequest) => ({
  [CALL_API]: {
    endpoint: 'ubs/contacts',
    method: 'get',
    params: externalContact,
    authenticated: true,
    types: [FETCH_EXTERNAL_CONTACTS_REQUEST, FETCH_EXTERNAL_CONTACTS_SUCCESS, FETCH_EXTERNAL_CONTACTS_FAILURE],
  },
});

export const getContactHistory = (contactId: number) => ({
  [CALL_API]: {
    endpoint: `contacts/${contactId}/history`,
    method: 'get',
    authenticated: true,
    types: [CONTACTS_HISTORY_FETCH_REQUEST, CONTACTS_HISTORY_FETCH_SUCCESS, CONTACTS_HISTORY_FETCH_FAILURE],
  },
});

/**
 * Action to merge contacts
 * @param contactIds Array of contact IDs to merge
 * @param mergedContactFields Fields to update the target contact with, or null to only migrate CRM issues without modifying contact
 * @param mergeToContactId Target contact ID to merge into
 */
export const mergeContacts = (
  contactIds: number[],
  mergedContactFields: IContactRequest | null = null,
  mergeToContactId: number
) => ({
  [CALL_API]: {
    endpoint: `contacts/merge-contacts`,
    method: 'post',
    body: {
      contactIds,
      mergedContactFields,
      mergeToContactId,
    },
    authenticated: true,
    types: [CONTACT_MERGE_REQUEST, CONTACT_MERGE_SUCCESS, CONTACT_MERGE_FAILURE],
  },
});

export const reassignSubmissions = (sourceContactId: number, targetContactId: number) => ({
  [CALL_API]: {
    endpoint: `contacts/reassign-submissions`,
    method: 'post',
    body: {
      sourceContactId,
      targetContactId,
    },
    authenticated: true,
    types: [REASSIGN_SUBMISSIONS_REQUEST, REASSIGN_SUBMISSIONS_SUCCESS, REASSIGN_SUBMISSIONS_FAILURE],
  },
});

export const createCCList = (createListRequest: ICreateListRequest) => ({
  [CALL_API]: {
    endpoint: `commlink/contacts/create-list`,
    method: 'post',
    body: createListRequest,
    authenticated: true,
    types: [CREATE_CC_LIST_REQUEST, CREATE_CC_LIST_SUCCESS, CREATE_CC_LIST_FAILURE],
  },
});

export const getConstantContactOAuthUri = () => ({
  [CALL_API]: {
    endpoint: `auth/constantcontact`,
    method: 'post',
    body: {},
    authenticated: true,
    types: [
      GET_CONSTANT_CONTACT_OAUTH_URI_REQUEST,
      GET_CONSTANT_CONTACT_OAUTH_URI_SUCCESS,
      GET_CONSTANT_CONTACT_OAUTH_URI_FAILURE,
    ],
    hideLoadingWidget: false,
  },
});

export const disconnectConstantContact = () => ({
  [CALL_API]: {
    endpoint: `constant-contact/disconnect`,
    method: 'get',
    body: {},
    authenticated: true,
    types: [
      DISCONNECT_CONSTANT_CONTACT_REQUEST,
      DISCONNECT_CONSTANT_CONTACT_SUCCESS,
      DISCONNECT_CONSTANT_CONTACT_FAILURE,
    ],
    hideLoadingWidget: false,
  },
});

export const getCampaignUrl = (campaignId: string) => ({
  [CALL_API]: {
    endpoint: `contacts/campaigns/${campaignId}`,
    method: 'get',
    body: {},
    authenticated: true,
    types: [GET_CAMPAIGN_URL_REQUEST, GET_CAMPAIGN_URL_SUCCESS, GET_CAMPAIGN_URL_FAILURE],
    hideLoadingWidget: false,
  },
});

export const exportListToCC = (listId: number) => ({
  [CALL_API]: {
    endpoint: `export-constant-contact/list/${listId}`,
    method: 'get',
    body: {},
    authenticated: true,
    types: [EXPORT_LIST_TO_CC_REQUEST, EXPORT_LIST_TO_CC_SUCCESS, EXPORT_LIST_TO_CC_FAILURE],
    hideLoadingWidget: false,
  },
});

export const checkDuplicateContact = (email?: string, phone?: string) => ({
  [CALL_API]: {
    endpoint: `agencies/contacts/check-duplicate`,
    method: 'get',
    params: {
      ...(email && { email }),
      ...(phone && { phone }),
    },
    authenticated: true,
    types: [CHECK_DUPLICATE_CONTACT_REQUEST, CHECK_DUPLICATE_CONTACT_SUCCESS, CHECK_DUPLICATE_CONTACT_FAILURE],
    hideLoadingWidget: true,
  },
});
export const auth0ForgotPassword = (email: string) => ({
  [CALL_API]: {
    endpoint: `auth0-forgot-password`,
    method: 'post',
    body: { email },
    authenticated: true,
    types: [AUTH0_FORGOT_PASSWORD_REQUEST, AUTH0_FORGOT_PASSWORD_SUCCESS, AUTH0_FORGOT_PASSWORD_FAILURE],
    hideLoadingWidget: false,
  },
});

export const fetchMatchingContacts = (agencyId: number, email: string) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/contacts/matching`,
    method: 'get',
    params: { email },
    authenticated: true,
    types: [FETCH_MATCHING_CONTACTS_REQUEST, FETCH_MATCHING_CONTACTS_SUCCESS, FETCH_MATCHING_CONTACTS_FAILURE],
    hideLoadingWidget: true,
  },
});
